import { render, staticRenderFns } from "./ArticleFormUpdate.vue?vue&type=template&id=cf39a4e0&"
import script from "./ArticleFormUpdate.vue?vue&type=script&lang=js&"
export * from "./ArticleFormUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports